





























import { Component, Vue, Prop } from "vue-property-decorator";
import { AlertFeed } from "@/models";
import EntryItem from "@/components/EntryItem.vue";
import { DATE_FORMAT } from "./DatePicker.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    EntryItem,
  },
})
export default class AlertFeedItem extends Vue {
  @Prop() readonly item!: AlertFeed;
  @Getter("lastDate") readonly lastDate!: string;

  onClick() {
    this.$router.push({
      name: "InvestorSummary",
      params: {
        type: this.item.campaignLaunch.product.type,
        id: this.item.campaignLaunch.product.id,
      },
      query: {
        from: this.item.date,
        to: this.lastDate,
        radio: this.item.isRadio ? "1" : "0",
        tv: this.item.isTV ? "1" : "0",
      },
    });
  }
}
